import { SubcontractorField } from "./types";
import * as z from "zod";
import { assignIn } from "lodash";

export const SubcontractorSchema = (id?: string | number) => {
  const schema = {
    [SubcontractorField.COMPANY_ID]: z.string().min(1).optional(),
    [SubcontractorField.ARABIC_NAME]: z.string().min(1),
    [SubcontractorField.ENGLISH_NAME]: z.string().min(1),
    [SubcontractorField.CICPA_ID]: z.string().min(1),
    [SubcontractorField.PHONE]: z.string().min(1),
    [SubcontractorField.ADDCI]: z.string().min(1),
    [SubcontractorField.TRADE_LICENSE_EXPIRY]: z.date(),
    [SubcontractorField.TRADE_LICENSE]: z.string().min(1),
  };

  if (id) {
    assignIn(schema, {
      [SubcontractorField.UNIFIED_ID]: z.string().min(1),
    });
  }

  return z.object(schema);
};
